/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Match_MatchedInputs */

const cs_demands_match_matched = /** @type {(inputs: Demands_Match_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se shodami`)
};

const en_demands_match_matched = /** @type {(inputs: Demands_Match_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With matches`)
};

/**
* | output |
* | --- |
* | "With matches" |
*
* @param {Demands_Match_MatchedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_match_matched = /** @type {((inputs?: Demands_Match_MatchedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Match_MatchedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_match_matched(inputs)
	return cs_demands_match_matched(inputs)
});